import './Login.scss';
import React from "react";
import { apiAddress, get, post } from '../../index.js';
import Loader from '../../components/Loader/Loader';
import BannerTitle from '../../components/BannerTitle/BannerTitle';
import CustomMarkdown from '../../components/CustomMarkdown/CustomMarkdown';
import { Button, Checkbox, FormControlLabel, FormGroup, TextField } from '@mui/material';
import Logo from '../../assets/capn2.png';
import { Link } from 'react-router-dom';
import  { Navigate, useNavigate, useHistory } from 'react-router-dom'

function Login(props) {
  let navigate = useNavigate();

  const [state, setState] = React.useState({
    working:false,
    error:false,
    username:'',
    password:''
  });


  React.useEffect(() => {
    document.title = "Login - CAPN";
  }, []);

  const handleUsernameChange = (event) => {
    setState(prevState => ({
      ...prevState,
      username:event.target.value,
    }));
  }

  const handlePasswordChange = (event) => {
    setState(prevState => ({
      ...prevState,
      password:event.target.value,
    }));
  }

  const handleKeyPress = (event) => {
    if (event.charCode === 13) {
      handleSubmitLogin();
    }
  }

  const handleSubmitLogin = async () => {
    // handleLogin(e) {
    //   e.preventDefault();
    //   this.setState({
    //     loading: true,
    //   });
    //   this.form.validateAll();
    //   const { dispatch, history } = this.props;
    //   if (this.checkBtn.context._errors.length === 0) {
    //     dispatch(login(this.state.username, this.state.password))
    //       .then(() => {
    //         history.push("/profile");
    //         window.location.reload();
    //       })
    //       .catch(() => {
    //         this.setState({
    //           loading: false
    //         });
    //       });
    //   } else {
    //     this.setState({
    //       loading: false,
    //     });
    //   }
    // }

    setState(prevState => ({
      ...prevState,
      working:true,
      error:false
    }));

    post('auth/local', {
      identifier: state.username,
      password: state.password
    }).then(res => {
      setState(prevState => ({
        ...prevState,
        working:false
      }));
      const { jwt, user } = res;
      window.localStorage.setItem('jwt', jwt)
      window.localStorage.setItem('user', JSON.stringify(user))
      navigate('/profile');
      window.location.reload();
    }).catch(e => {
      console.log(e);
      setState(prevState => ({
        ...prevState,
        working:false,
        error:true,
      }));
    });

  }

  return (
    <div className="Login Page">
       {/* {
        props.userInfo &&
        <Navigate to="/profile" />
      } */}
      <BannerTitle title={'Log In'}/>
      <div className="section">
        <div className={state.triedSubmitting && !state.isAuthenticated ? 'form failed' : 'form'}>
          <img src={Logo}/>
          <br/>
          <TextField disabled={state.working} value={state.username} id="outlined-basic" label="Email" variant="outlined" className="field username"  onChange={(e) => handleUsernameChange(e)} onKeyPress={(e) => handleKeyPress(e)}/>
          <TextField disabled={state.working} value={state.password} id="outlined-password-input" type="password" label="Password" variant="outlined" className="password" onChange={(e) => handlePasswordChange(e)} onKeyPress={(e) => handleKeyPress(e)}/>
          { state.error && 
            <p className="error">The email or password you entered is incorrect.</p>
          }
          
          <a  disabled={state.working} href="/reset-password" className="field forgot-password-link">Forgot your password?</a>
          <Button  disabled={state.working} onClick={() => handleSubmitLogin()} variant="contained" className="field">Sign In</Button>
          <div className="field or-hr"><hr/><span>or</span></div>
          <Button  disabled={state.working} className="field" href={`${apiAddress}/admin`} target="_blank" variant="outlined">Sign In to the Admin Panel</Button>
          <Link  disabled={state.working} to="/register" className="register-link">Don't have an account? Become a member now!</Link>
        </div> 
      </div>
    </div>
  );
}

export default Login;
